// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterOutlinedSvg from "@ant-design/icons-svg/es/asn/TwitterOutlined";
import AntdIcon from '../components/AntdIcon';

var TwitterOutlined = function TwitterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterOutlinedSvg
  }));
};

TwitterOutlined.displayName = 'TwitterOutlined';
export default React.forwardRef(TwitterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TwitterOutlined.js
// module id = 1967
// module chunks = 0